import React from "react";
import Details from "../components/product/Details";
import Footer from "../components/shared/footer/Footer";
import Header from "../components/shared/header/Header";

const ProductDetails = () => {
  return (
    <>
      <Header />
      <Details />
      <Footer />
    </>
  );
};

export default ProductDetails;
